import React from 'react';
import { AdminDataTable } from '../../../../components';

const SupportQualificationLevel = () => {

    let url = 'qualification-level/';

    let columns = ["name"];
    let headers = ["Name", "Actions"];

    return (
        <AdminDataTable
            title="Qualification Level"
            header={headers}
            column={columns}
            url={url}
            excelheader={['Name']}
            filename="Qualification Level.xlsx"
            excelurl="degree-level-import/"
        />
    );
};

export default SupportQualificationLevel;